import React from 'react'
import '../css/bloglist.css'
import { NavLink } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

export const BlogList = ({blog}) => {
   const url = process.env.REACT_APP_BASE_URL

  const formattedDate = new Date(blog.created).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });

 
   // Function to decode HTML entities
   const decodeHtmlEntities = (text) => {
    const parser = new DOMParser();
    const decodedString = parser.parseFromString(text, 'text/html').documentElement.textContent;
    return decodedString;
  };

  // Strip HTML tags, decode entities, and truncate
  const plainTextDescription = decodeHtmlEntities(
    blog.description.replace(/<\/?[^>]+(>|$)/g, '')
  ).substring(0, 50);

  return (
// start 
<div className="grid-item">

  <img 
    src={`${url}/images/${blog.image}`} 
    alt={blog.title} 
    className="grid-item-image" 
  />

  {/* Blog Content */}
  <div className="grid-item-content">
     {/* Blog Title with Tooltip */}
     <h3
          className="grid-item-title"
          data-tooltip-id="blogTitleTooltip" // Connects to Tooltip
          data-tooltip-content={blog.title} // Tooltip content
        >
          {blog.title}
        </h3>
        <Tooltip 
  id="blogTitleTooltip" 
  place="top" 
  style={{
    backgroundColor: '#333',
    color: '#fff',
    maxWidth: '300px', // Optional: Set max width for better readability
    whiteSpace: 'normal', // Allow line breaks for long text
    wordWrap: 'break-word' // Break long words if necessary
  }} 
/>

    
    {/* Blog Description */}
    {/* <div 
      className="grid-item-description" 
      dangerouslySetInnerHTML={{
        __html: blog.description.length > 30
          ? `${blog.description.substring(0, 50)}...`
          : blog.description,
      }} 
    /> */}
     <p className="grid-item-description">
          {plainTextDescription}...
        </p>

    {/* Blog Actions */}
    <div className="grid-item-actions">
      <p className="grid-item-date">{formattedDate}</p>
      <NavLink 
        to={`/blogs/${blog._id}`} 
        className="grid-item-link"
      >
        Read More
      </NavLink>
    </div>
  </div>
</div>



//  end




//   <div className='blog-item'>
//     <div className='blog-item-img-container'>
//     <img className='blog-img' src={`${url}/images/${blog.image}`} alt={blog.title}  />
//     </div>
//     <div className='blog-item-info'>
//       <div className='blog-item-title'>
//       {blog.title}
//       </div>
//      <div className='blog-item-desc'>
//      <div className='blog-item-desc-para'
//   dangerouslySetInnerHTML={{
//     __html: blog.description.length > 100
//       ? `${blog.description.substring(0, 30)}...`
//       : blog.description,
//   }}
// ></div>

//      </div>
//      <div className='blog-item-date-link-container'>
//      <p>{formattedDate}</p>
//           <NavLink to={`/blogs/${blog._id}`} className='read-more-link'>Read More</NavLink>
//     </div>
  
//     </div>

//   </div>
  )
}
